import React from "react";
import AdminShell from "../components/AdminShell.jsx";

export default function AdminDashboard() {
  return (
    <AdminShell>
      <h3 className="mb-3">Dashboard</h3>
      <p>Bienvenido al panel de administración.</p>
    </AdminShell>
  );
}
